import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { NewsLetterMailServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin News Letter Mail Master section
 */
const useListNewsLetterMail = (
  [page_no],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ["newslettermail-list", page_no],
    NewsLetterMailServices.newslettermailList,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};

const useNewsLetterMailDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsLetterMailServices.deleteNewsLetterMail, {
    onSuccess,
    onError,
  });
};
export { useListNewsLetterMail, useNewsLetterMailDelete };
